import { render, staticRenderFns } from "./DetailApprovalBarangHilang.vue?vue&type=template&id=11a2ca7f&"
import script from "./DetailApprovalBarangHilang.vue?vue&type=script&lang=js&"
export * from "./DetailApprovalBarangHilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports